import React, { Component } from 'react';
import Header from '../../Header'
import { buttons } from '../../../helpers/const'

class Charges extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { currentUser, charges, invoices } = this.props;
    return (
      <React.Fragment>
        <Header
          buttonText={buttons.persona.text}
          buttonUrl={buttons.persona.url}
          currentUser={currentUser}
        />
        <div className="flex flex-center flex-justify-center" style={{ paddingTop: '80px' }}>
          <div className="col-12 md-px3 py-110 sm-py4" style={{ maxWidth: '350px' }}>
            <p className="title center mb-30">Subscription Invoices</p>

            {invoices.length > 0
              ? invoices.map(invoice => (
                <div key={invoice.id} className="mb-30">
                  <div className="bg-white box-shadow-box border border-gallery mb-10 p-20 rounded-6">
                    <p className="fs-11 mb1 sfpro-regular">{invoice.created}</p>

                    <div className="flex flex-justify fs-18 mb2 text-tuna">
                      <p className="pr2">Subscription {invoice.plan.nickname}</p>

                      <p>${invoice.total/100}</p>
                    </div>

                    <a
                      className="btn btn--primary btn--primary--wisp-pink btn--fs-12 btn--lh-28 col-12"
                      href={invoice.hosted_invoice_url}
                      style={{ maxWidth: '120px' }}
                    >
                      Download
                    </a>
                  </div>
                </div>
              ))
              : <p className="center">You don't have any invoices yet.</p>
            }
          </div>
        </div>
        <div className="flex flex-center flex-justify-center">
          <div className="col-12 md-px3" style={{ maxWidth: '350px' }}>
            <p className="title center mb-30">Package Invoices</p>

            {charges.length > 0
              ? charges.map(charge => (
                <div key={charge.id} className="mb-30">
                  <div className="bg-white box-shadow-box border border-gallery mb-10 p-20 rounded-6">
                    <p className="fs-11 mb1 sfpro-regular">{charge.created_at}</p>

                    <div className="flex flex-justify fs-18 mb2 text-tuna">
                      {charge.type === 'Persona' && <p className="pr2">Persona {charge.persona && charge.persona.name}</p>}
                      {charge.media_plan && <p className="pr2">Media Plan id: {charge.media_plan.id}</p>}
                      {charge.package && <p className="pr2">Package: {charge.package.name}</p>}

                      <p>${charge.amount / 100}</p>
                    </div>

                    <a
                      className="btn btn--primary btn--primary--wisp-pink btn--fs-12 btn--lh-28 col-12"
                      href={charge.receipt_url}
                      style={{ maxWidth: '120px' }}
                    >
                      Download
                    </a>
                  </div>
                </div>
              ))
              : <p className="center">You don't have any invoices yet.</p>
            }
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default Charges
